import authentication from "@irati/auth"
import env from "@irati/utils/env"
import environment from "@irati/utils/constants/environment"

// Docs: "/docs/web/devToggles.md"
class DevToggles {
  /**
   * @description: Rolling out VR experience for Wellness (WEL-1763)
   */
  showWellnessVRExample() {
    const allowedDomainsForTesting = ["qa-business", "test-staging-business", "test-prod-business"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showHomePageFestiveCard() {
    const allowedDomainsForTesting = ["kimbo", "apple", "guild", "zenitechteam", "codethread", "recognitionn", "festive"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showUnreadIndicator() {
    const allowedDomainsForTesting = ["group-recognition", "kimbo", "apple", "guild", "zenitechteam", "codethread", "recognitionn"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showSSOFeatureFlag() {
    const allowedDomainsForTesting = [
      "home",
      "testaccount1",
      "testaccount2",
      "testaccount3",
      "testaccount4",
      "testaccount5",
      "testaccount6",
      "testaccount12",
      "abcdefg",
      "test-account-self-renewal-training",
      "test-account-upsell",
      "test-account-renew-integ-w-disc"
    ]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  useCheckoutCom() {
    return env.GRAPH_QL === "v2"
  }

  showSendingTeamsSetting() {
    const allowedDomainsForTesting = ["zenitechteam", "guild", "flavio"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showRecommendedBrandsSlider() {
    const allowedDomainsForTesting = ["zenitechteam", "guild", "raultenant", "home"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  isSSOfromVivup() {
    const allowedDomainsForTesting = ["raultenant", "andradasso"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showPayrollPayBenefits() {
    const allowedDomainsForTesting = ["guild", "apple"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showTopRedeemedPerksCategory() {
    const allowedDomainsForTesting = ["home"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showPayrollPayNewFlow() {
    const allowedDomainsForTesting = ["guild", "kimbo", "apple"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showRewardMinMaxSettings() {
    return this.isNotProduction() || this.isProductionGuild()
  }

  private isProduction() {
    return env.ENVIRONMENT_NAME === environment.PRODUCTION
  }

  private isNotProduction() {
    return !this.isProduction()
  }

  private isProductionGuild() {
    return this.isProduction() && this.businessIs(["guild"])
  }

  private businessIs(domains: string[]) {
    return authentication.isLoggedIn() && domains.includes(authentication.business().subdomain)
  }
}

export default new DevToggles()
